import React, { PropTypes } from 'react';
import Translator from 'bazinga-translator';
import {optionsButton} from '../../svgs.jsx';

const DraftSettingsTrigger = (props)=> {
    return (
    <div className="box-drafts__trigger" onClick={props.onTrigger}>
        <div>{optionsButton()}<p>{Translator.trans('drafts.options.header', [], 'app')}</p></div>
        <div>
            <div className="burger"><span></span></div>
            <p>{Translator.trans('drafts.options.close', [], 'app')}</p></div>
    </div>
    )
};

DraftSettingsTrigger.propTypes = {
    onTrigger: PropTypes.func.isRequired
};

export default DraftSettingsTrigger;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Draft/DraftSettingsTrigger.jsx